import React from "react";

export default function About() {
  return (
    <section class="about section-padding prelative" id="about">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="sectioner-header text-center">
              <h3>Acerca de R & H</h3>
              <span class="line"></span>
              <p>
                R&H es una empresa innovadora y dinámica que se dedica al
                crecimiento digital de negocios físicos y digitalizables. Nos
                especializamos en brindar soluciones tecnológicas adaptadas a
                las necesidades únicas de cada cliente, ayudándolos a aprovechar
                al máximo las oportunidades que ofrece el mundo digital.
              </p>
            </div>
            <div class="section-content text-center">
              <div class="row">
                <div class="col-md-4">
                  <div class="icon-box wow fadeInUp" data-wow-delay="0.2s">
                    <i class="fa fa-life-ring" aria-hidden="true"></i>
                    <h5>Apoyo</h5>
                    <p>
                      Nuestro enfoque se centra en el diseño y desarrollo de
                      landing pages,tiendas virtuales, etc., atractivas y
                      efectivas, que no solo llamen la atención de los
                      visitantes, sino que también impulsen la conversión y el
                      compromiso.
                    </p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="icon-box wow fadeInUp" data-wow-delay="0.4s">
                    <i class="fa fa-mobile" aria-hidden="true"></i>
                    <h5>Digitalización</h5>
                    <p>
                      La digitalización permite realizar procesos de manera más
                      rápida y económica, lo que se traduce en una mayor
                      productividad para la empresa. Al automatizar tareas y
                      optimizar procesos, se pueden lograr resultados más
                      eficientes y rentables.
                    </p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="icon-box wow fadeInUp" data-wow-delay="0.6s">
                    <i class="fa fa-bolt" aria-hidden="true"></i>
                    <h5>Soluciones Rápidas</h5>
                    <p>
                      La transformación digital permite ofrecer una experiencia
                      más personalizada y eficiente a los clientes, lo que puede
                      aumentar la satisfacción y fidelidad de estos. La
                      digitalización facilita la interacción con los clientes,
                      brindando un servicio más ágil y adaptado a sus
                      necesidades.
                    </p>
                  </div>
                </div>
              </div>
              <a class="about-btn">Qué es R & H</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
